import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import EditSchedule from '@/ui/pages/Reports/schedules/EditSchedule';

// HS-961 / HS-1603: edit one schedule; template and scope are locked (HS-891).
export const Route = createFileRoute('/_dashboard/reports/schedules/$id/edit')({
  beforeLoad: requireRoute('/reports/schedules/$id/edit'),
  component: EditSchedule,
});
